import { api } from "../adapters/api"

const auth = () => ({ "Authorization": "Bearer " + localStorage.getItem("jwtToken") })

// Catalogul de planuri recurente (doar cele active, cu cote incluse). Vezi ProductsController.
export const getSubscriptionPlans = () =>
  api.get("api/v1/subscription-plans", auth()).then((r: any) => r.json())

// Cotele incluse rămase pe perioada curentă; hasActivePlan=false dacă nu există abonament.
export const getEntitlementUsage = () =>
  api.get("api/v1/employer/entitlements/usage", auth()).then((r: any) => r.json())
